import React, { useContext } from 'react';

import b_ from 'b_';

import { Button } from 'client/common/components/lego';

import { SurveysGoal, SurveyType } from 'client/common/types';

import { SurveyState } from 'client/common/store/reducers/survey/types';
import { ListMode } from 'client/common/store/reducers/surveys/types';

import ListModeContext from 'client/common/contexts/list-mode';

import { genSurveyLink, genStatisticsLink } from 'client/common/utils/survey-link';
import I18N from 'assets/i18n/brandlift-project';

import { ComponentProps } from './types';

import './survey-item-button.css';

const i18n = I18N.list.surveyList;
const b = b_.with('survey-item-button');

function LaunchButton(props: ComponentProps) {
    const { sendGoals, slug, surveyType } = props;

    const callback = () => {
        sendGoals([SurveysGoal.ClickSurveyCardLaunchButton]);
    };

    return (
        <Button
            className={b({ type: 'launch' })}
            onClick={callback}
            type='link'
            url={genSurveyLink({ slug, surveyType })}
            view='action'
            size='m'
        >
            {i18n.launchButtonTitile}
        </Button>
    );
}

function StatisticsButton(props: ComponentProps) {
    const { sendGoals, slug, state, surveyType, surveyScope } = props;

    const callback = () => {
        sendGoals([SurveysGoal.ClickSurveyCardStatisticsButton]);
    };

    const active = [
        SurveyState.Active,
        SurveyState.Paused,
        SurveyState.Completed,
        SurveyState.Closed
    ].includes(state);

    return (
        <Button
            className={b({ type: 'statistics' })}
            onClick={callback}
            disabled={!active}
            type='link'
            url={genStatisticsLink({ slug, surveyType, surveyScope })}
            target='_blank'
            rel='noopener noreferrer'
            view='default'
            size='m'
        >
            {i18n.statisticsButtonTitle}
        </Button>
    );
}

const SURVEY_TYPES_WITHOUT_STATISTICS: Set<SurveyType> = new Set(['createSegment']);

export default function SurveyItemButton(props: ComponentProps) {
    const { state, surveyType } = props;

    const listMode = useContext(ListModeContext);

    if (state === SurveyState.Draft) {
        if (listMode === ListMode.AgencyClient) {
            return null;
        }

        return <LaunchButton {...props} />;
    }

    return SURVEY_TYPES_WITHOUT_STATISTICS.has(surveyType) ? null : <StatisticsButton {...props} />;
}
